import React from "react";
import { Tabs } from "antd";
import Layout from "@/Layout";
import { getQueryVariable, isWebPSupported } from "$ACTIONS/helper";
import MyPromotionTabs from "@/MyPromotionTabs/index";
import PromotionList from "@/Promotion";
import MyRebate from "@/Promotion/MyRebate";
import { connect } from "react-redux";
import { promotionActions } from "$STORE/promotionSlice";
import { getPromotionListAction } from "$STORE/thunk/promotionThunk";
import { getStaticPropsFromStrapiSEOSetting } from "$DATA/seo";
import { storePagePiwikData, clearPagePiwikData } from "$ACTIONS/piwikData";
import { setSupportFormats, getSupportFormats } from "$ACTIONS/imageHandler";

export async function getStaticProps() {
    return await getStaticPropsFromStrapiSEOSetting("/โปรโมชั่น"); //參數帶本頁的路徑
}

const { TabPane } = Tabs;

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogin: false,
            supportFormats: getSupportFormats(),
        };
    }

    async componentDidMount() {
        global.Pushgtagpiwikurl &&
            global.Pushgtagpiwikurl("promotion", "Promotion Page");
        storePagePiwikData("promotion", "Promotion Page");

        // 確保支援格式初始化完成
        await setSupportFormats();
        // 更新狀態為最新的支援格式
        this.setState({ supportFormats: getSupportFormats() });

    }

    componentWillUnmount() {
        clearPagePiwikData();
    }

    getExtension = () => {
        const { avif, webp } = this.state.supportFormats || {};

        return avif ? "avif" : webp ? "webp" : "jpg";
    };

    render() {
        const { isLogin } = this.state;
        const extension = this.getExtension();
        const imgsrc = `${
            process.env.BASE_PATH
        }/img/promotions/promo_2025.${extension}`;
        return (
            <Layout
                seoData={this.props.seoData}
                status={1}
                getPromotionList={() => {
                    if (this.props.topTabIndex === "1") {
                        // 點擊 header Promotion tab，刷新 Promotion List
                        this.props.setPromotions();
                    }
                }}
                setLoginStatus={(v) => {
                    this.setState({ isLogin: v });
                }}
            >
                <div className="common-distance-wrap common-distance promotions-banner">
                    <img
                        src={imgsrc}
                        style={{ width: "100%", borderRadius: 20 }}
                    />
                </div>

                <div className="common-distance-wrap promotions-content">
                    <div className="common-distance promotion-tabs">
                        <Tabs
                            defaultActiveKey="1"
                            className="border-tabs"
                            activeKey={this.props.topTabIndex}
                            onChange={(tabKey) => {
                                switch (tabKey) {
                                    case "1":
                                        Pushgtagdata(
                                            "Promotion",
                                            "Switch to Promo",
                                            "Promotion_Tab_C_Promotion"
                                        );
                                        break;
                                    case "2":
                                        Pushgtagdata(
                                            "Promotion",
                                            "Switch to MyPromotion",
                                            "Promotion_Tab_C_MyPromotion"
                                        );
                                        break;
                                    case "3":
                                        Pushgtagdata(
                                            "Promotion",
                                            "Switch to Rebate",
                                            "Promotion_Tab_C_TurnoverRebate"
                                        );
                                        break;
                                }
                                if (tabKey !== "1" && !isLogin) {
                                    global.goUserSign(
                                        getQueryVariable("isAgent") === "1"
                                            ? "2"
                                            : "1"
                                    );
                                } else {
                                    this.props.changeTab(`${tabKey}`);
                                    if (tabKey === "2") {
                                        this.props.setMyPromotionSubtab(
                                            "inProgress"
                                        );
                                    }
                                }
                            }}
                        >
                            <TabPane
                                className="upper-tab"
                                tab={<div>โปรโมชั่น</div>} //优惠
                                key="1"
                            >
                                {this.props.topTabIndex === "1" && (
                                    <PromotionList isLogin={isLogin} />
                                )}
                            </TabPane>
                            <TabPane
                                tab={<div>โบนัสของฉัน</div>} //我的优惠
                                key="2"
                            >
                                {this.props.topTabIndex === "2" && (
                                    <MyPromotionTabs />
                                )}
                            </TabPane>
                            <TabPane
                                tab={<div>เงินคืน</div>} //返水
                                key="3"
                            >
                                {this.props.topTabIndex === "3" && <MyRebate />}
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        topTabIndex: state.promotion.topTabIndex,
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        changeTab: (i) => {
            dispatch(promotionActions.changeTab(i));
        },
        setMyPromotionSubtab: (i) => {
            dispatch(promotionActions.setMyPromotionSubtab(i));
        },
        setPromotions: () => {
            dispatch(getPromotionListAction());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
